module.exports = __webpack_public_path__ + "FCTC_logo.png?0de2b3e7beddbaf485c088b8489c86c6";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/FCTC_logo.png
// module id = 39
// module chunks = 0